import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as FeedStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed";
import { Route as LeadStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead";
import { Route as UserStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute, RouteStaticData } from "utils/createTenantFileRoute.ts";

const staticData: RouteStaticData = {
    permissions: [PermissionEnum.ToolStructureForm, PermissionEnum.ToolStructureFeed, PermissionEnum.ToolStructureUser],
    showInSideMenu: true,
    sideMenuParent: "lazy", // Is defined below after parent route is initialized
    label: "pages.tool.structure.title",
    sort: 1,
    redirects: [LeadStructurePage, UserStructurePage, FeedStructurePage],
    defaultRedirect: LeadStructurePage,
};

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/structure/")({
    component: ToolStructurePage,
    staticData,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.structure.title"),
    }),
});

function ToolStructurePage() {
    return <RedirectPage />;
}

// Delay sideMenuParent after parent route is initialized
import("routes/_authenticated/$tenantSlug/_layout/tool/index.tsx").then((mod) => {
    staticData.sideMenuParent = mod.Route;
});
